import { render, staticRenderFns } from "./HistoryConfig.vue?vue&type=template&id=97867240&scoped=true&"
import script from "./HistoryConfig.vue?vue&type=script&lang=js&"
export * from "./HistoryConfig.vue?vue&type=script&lang=js&"
import style0 from "./HistoryConfig.vue?vue&type=style&index=0&id=97867240&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97867240",
  null
  
)

export default component.exports